var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7175 0.986853C11.8943 0.774714 11.8657 0.459432 11.6535 0.28265C11.4414 0.105868 11.1261 0.13453 10.9493 0.346668L7.35553 4.65921C6.63364 5.52548 6.12582 6.13299 5.68535 6.53073C5.25516 6.9192 4.95827 7.04266 4.66676 7.04266C4.37525 7.04266 4.07836 6.9192 3.64817 6.53073C3.2077 6.13298 2.69988 5.52548 1.97799 4.65921L1.05087 3.54667C0.874089 3.33453 0.558807 3.30587 0.346668 3.48265C0.13453 3.65943 0.105868 3.97471 0.28265 4.18685L1.2355 5.33027C1.92568 6.15851 2.4784 6.82179 2.97797 7.27291C3.49401 7.7389 4.02152 8.04266 4.66676 8.04266C5.312 8.04266 5.83951 7.7389 6.35555 7.27291C6.85512 6.8218 7.40783 6.15852 8.09801 5.33029L11.7175 0.986853Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineCheck);
export default __webpack_public_path__ + "static/media/outline-check.d07e337e8182cd3a22eaa4b720bcbbec.svg";
export { ForwardRef as ReactComponent };